export type PageTarget = { documentId: string; page: number };

const PAGE_TAG_HREF = /^#page-(\d+)-(\d+)$/;

// Reads a server-made page tag's href: "#page-<documentId>-<page>".
export const parsePageTag = (href: string): PageTarget | null => {
  const match = PAGE_TAG_HREF.exec(href);
  if (!match) return null;

  return { documentId: match[1], page: Number(match[2]) };
};

export const pageTagHref = ({ documentId, page }: PageTarget): string =>
  `#page-${documentId}-${String(page)}`;
